import { optionalTrimmedString } from '../../../lib/routeSearch';

export interface EndpointGeneratorRouteSearch {
  publisherId?: string;
  placementId?: string;
}

export function endpointGeneratorRouteSearchSchema(
  search: Record<string, unknown>,
): EndpointGeneratorRouteSearch {
  const publisherId = optionalTrimmedString(search['publisherId']);
  const placementId = optionalTrimmedString(search['placementId']);
  return {
    ...(publisherId ? { publisherId } : {}),
    ...(placementId ? { placementId } : {}),
  };
}
